import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";

const themeMap = {
    green: {
        border: "border-green-200",
        title: "text-green-900",
        amount: "text-green-800",
        item: "text-green-700",
        hover: "hover:bg-green-100",

        subItem: "text-green-600",
        subBg: "bg-green-50",
        subBorder: "border-green-200",
        divider: "border-green-100",
    },
    orange: {
        border: "border-orange-200",
        title: "text-orange-900",
        amount: "text-orange-800",
        item: "text-orange-700",
        hover: "hover:bg-orange-100",

        subItem: "text-orange-600",
        subBg: "bg-orange-50",
        subBorder: "border-orange-200",
        divider: "border-orange-100",
    },
};

const safeAmount = (val) => (Number(val) || 0).toLocaleString("en-IN");
const SubItemRow = ({ name, amount, idGeneralProduct, colors, onItemClick }) => (
    <div className={`flex justify-between items-center py-[4px] pl-2 ${colors.hover} cursor-pointer`} onClick={() => onItemClick?.({ idGeneralProduct })}>
        <span className={`text-[12.5px] ${colors.subItem}`}>{name}</span>
        <span className={`text-[12.5px] font-medium ${colors.subItem}`}>
            ₹ {safeAmount(Math.abs(amount))}
        </span>
    </div>
);

const ExpandableItem = ({ name, amount, sub = [], colors, onItemClick, idGeneralProduct }) => {
    const [open, setOpen] = useState(false);
    const hasSub = sub.length > 0;

    if (!hasSub) {
        return (
            <div className={`flex justify-between items-center py-[5px] ${colors.hover} cursor-pointer`} onClick={() => onItemClick?.({ idGeneralProduct })}>
                <span className={`text-[13px] truncate ${colors.item}`}>{name}</span>
                <span className={`text-[13px] font-medium ${colors.item}`}>
                    ₹ {safeAmount(Math.abs(amount))}
                </span>
            </div>
        );
    }

    return (
        <div className={`rounded-md border ${colors.subBorder} ${colors.subBg} overflow-hidden`}>
            <div
                onClick={() => setOpen(!open)}
                className={`flex items-center justify-between px-2.5 py-[5px] cursor-pointer transition ${colors.hover}`}
            >
                <div className="flex items-center gap-1.5">
                    <FontAwesomeIcon
                        icon={faChevronRight}
                        className={`text-[10px] transition-transform duration-200 ${open ? "rotate-90" : ""} ${colors.item}`}
                    />
                    <span className={`text-[13px] font-medium ${colors.item}`}>{name}</span>
                </div>
                <span className={`text-[13px] font-medium ${colors.item}`}>
                    ₹ {safeAmount(Math.abs(amount))}
                </span>
            </div>

            {/* Layer 3 — sub-items */}
            {open && (
                <div className={`px-3 pb-1.5 border-t border-dashed ${colors.divider} space-y-0.5`}>
                    {sub.map((s, i) => (
                        <SubItemRow key={i} {...s} colors={colors} onItemClick={onItemClick} />
                    ))}
                </div>
            )}
        </div>
    );
};

const ExpandableGroup = ({ title, total, items = [], theme = "green", onItemClick }) => {
    const [open, setOpen] = useState(false);
    const colors = themeMap[theme];

    return (
        <div className={`rounded-lg border ${colors.border} bg-white overflow-hidden`}>
            <div
                onClick={() => setOpen(!open)}
                className={`flex items-center justify-between px-3 py-[6px] cursor-pointer transition ${colors.hover}`}
            >
                <div className="flex items-center gap-2">
                    <FontAwesomeIcon
                        icon={faChevronRight}
                        className={`text-[12px] transition-transform duration-200 ${open ? "rotate-90" : ""} ${colors.title}`}
                    />
                    <span className={`text-[14px] font-semibold ${colors.title}`}>{title}</span>
                </div>
                <span className={`text-[14px] font-semibold ${colors.amount}`}>
                    ₹ {safeAmount(Math.abs(total))}
                </span>
            </div>

            {open && items.length > 0 && (
                <div className={`px-3 py-[6px] space-y-1.5 border-t border-dashed ${colors.divider}`}>
                    {items.map((item, index) => (
                        <ExpandableItem key={index} {...item} colors={colors} onItemClick={onItemClick} />
                    ))}
                </div>
            )}
        </div>
    );
};

export default ExpandableGroup;

// const ExpandableGroup = ({ title, total, items = [], theme = "green" }) => {
//     const [open, setOpen] = useState(true);
//     const colors = themeMap[theme];

//     return (
//         <div className={`rounded-lg border ${colors.border} bg-white overflow-hidden`}>

//             <div
//                 onClick={() => setOpen(!open)}
//                 className={`flex items-center justify-between px-3 py-[6px] cursor-pointer transition ${colors.hover}`}
//             >
//                 <div className="flex items-center gap-2">
//                     <FontAwesomeIcon
//                         icon={faChevronRight}
//                         className={`text-[12px] transition-transform duration-200 ${open ? "rotate-90" : ""
//                             } ${colors.title}`}
//                     />
//                     <span className={`text-[14px] font-semibold ${colors.title}`}>
//                         {title}
//                     </span>
//                 </div>

//                 <span className={`text-[14px] font-semibold ${colors.amount}`}>
//                     ₹ {total.toLocaleString("en-IN")}
//                 </span>
//             </div>

//             {open && items.length > 0 && (
//                 <div className="px-3 py-[6px] space-y-1 border-t border-dashed border-gray-200">
//                     {items.map((item, index) => (
//                         <div
//                             key={index}
//                             className="flex justify-between text-[14px]"
//                         >
//                             <span className={`truncate ${colors.item}`}>
//                                 {item.name}
//                             </span>
//                             <span className={`font-medium ${colors.item}`}>
//                                 ₹ {item.amount.toLocaleString("en-IN")}
//                             </span>
//                         </div>
//                     ))}
//                 </div>
//             )}
//         </div>
//     );
// };

// export default ExpandableGroup;
